const whatsAppMessageTemplate = {
  expiredMembersMessage: `Hello gymName,

Your gym software subscription is expired on expiryDate.
Good news - we have some exciting renewal offers available for you. Please contact us for offer details.

Thank you
zpotter gym software
`,
  renewalReminderMessage: `Hello gymName,

Your gym software subscription is going to expire on expiryDate.
Please renew your subscription to continue enjoying uninterrupted access to our gym software and all its features.

Thank you
zpotter gym software
`,

  pendingPaymentsMessage: `Hello gymName,

This is a gentle reminder that Rs.pendingAmount is pending in your gym software subscription.
Please clear the pending amount to have unlimited access to our gym software.

Thank you
zpotter gym software
`,

  whatsAppAd: ``,
  otherMessage: "",
};

export const getWhatsAppNumber = (mobileNumber, defaultCountryCode = "91") => {
  if (!mobileNumber) return null;
  let number = String(mobileNumber)?.replace(/\D/g, "");
  // Remove starting 0 for Indian local numbers like 09876543210
  if (number?.length === 11 && number?.startsWith("0")) {
    number = number?.substring(1);
  }
  // If 10-digit Indian number, add 91
  if (number?.length === 10) {
    number = `${defaultCountryCode}${number}`;
  }
  return number;
};

export const openWhatsApp = (
  mobileNumber,
  prefilledMessage,
  pendingAmount,
  expiryDate,
  gymName
) => {
  const whatsappNumber = getWhatsAppNumber(mobileNumber);
  const whatsAppText = whatsAppMessageTemplate[prefilledMessage]
    .replace("pendingAmount", pendingAmount)
    ?.replace("expiryDate", expiryDate)
    ?.replace("gymName", gymName);
  if (whatsappNumber) {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      whatsAppText
    )}`;
    window.open(url, "_blank");
  } else {
    alert("Invalid mobile number");
  }
};
